/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export { AvatarDropdown, AvatarName, Footer, Question, SelectLang };

export { IconModal } from './IconModal';
export { MyIcon } from './IconModal/MyIcon';
export { IconSelect } from './IconSelect';
export { MENU_ICONS, MenuIconKey } from './IconSelect/iconMap';

export { MyButton } from './MyButton';
export { MyModalForm } from './MyModalForm';
export {
  FormScene,
  MyProColumn,
  MyProTable,
  MyProTableRef,
} from './MyProTable';

export { MyTree } from './MyTree';
